import { useState } from 'react';
import { KModal } from '@/ui-library/components/molecules/KModal';
import { KText } from '@/ui-library/components/text';
import { notifyAdminCredits } from './backgroundCheckApi';
import { useShowToast } from '@/hooks';

export const InsufficientCreditsModal = ({ isOpen, onClose, capError }) => {
  const [isNotifying, setIsNotifying] = useState(false);
  const toast = useShowToast();
  const canNotifyAdmin = !capError?.user_has_manage_org_fraud_detector;
  const reminderSent = capError?.reminder_sent_recently;

  const handleNotifyAdmin = async () => {
    setIsNotifying(true);
    try {
      await notifyAdminCredits();
      toast({ title: 'Admin has been notified about insufficient credits' });
      onClose();
    } catch {
      toast({ title: 'Failed to notify admin', status: 'error' });
    } finally {
      setIsNotifying(false);
    }
  };

  return (
    <KModal
      isOpen={isOpen}
      onClose={onClose}
      title="Insufficient credits"
      ctaLabel={
        canNotifyAdmin
          ? reminderSent
            ? 'Admin notified'
            : 'Notify admin'
          : 'Contact support'
      }
      hideCloseButton={true}
      ctaAction={
        canNotifyAdmin
          ? handleNotifyAdmin
          : () => {
              window.Pylon?.('show');
              onClose();
            }
      }
      isCtaLoading={isNotifying}
      ctaButtonProps={canNotifyAdmin ? { isDisabled: reminderSent } : {}}
      enableCancelBtn={canNotifyAdmin}
      modalContentProps={{ borderRadius: '4px' }}
      modalFooterProps={{
        borderTop: '1px solid',
        borderColor: 'secondary-200',
        pt: '12px',
      }}
    >
      <KText color="secondary-700" mb="12px">
        You don&apos;t have enough credits to review this candidate with fraud
        detector
        {!canNotifyAdmin && '. Contact support for more credits.'}
      </KText>
    </KModal>
  );
};
